const AWS = require('aws-sdk');

export default function accessImage(filename) {
    if (!filename) return '';

    const myBucket = 'us-east-1-992382708231-transferfamily-data';
    const myKey = filename;
    const signedUrlExpireSeconds = 900;

    const s3 = new AWS.S3({
        accessKeyId: 'AKIA6ODU6NIDQVJILR4K',
        signatureVersion: 'v4',
        region: 'us-east-1',
        secretAccessKey: '0OyW6sIzjLliQnS+TJYg+aoJRVMCHu1vUub+OtQp'
    });
    const url = s3.getSignedUrl('getObject', {
        Bucket: myBucket,
        Key: myKey,
        Expires: signedUrlExpireSeconds
    });

    return url;
}
